module.exports = "<app-payor-date-range-report reportPath=\"CreateHistoryReport\" reportName=\"Dispatch History Report\" isExcel=\"true\" isPost=\"true\" title=\"Dispatch History Report\" isDateRange=\"true\" multiPayorDropdown=\"true\" multiProviderDropdown=\"true\"></app-payor-date-range-report>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manager-reports/report-dispatch/report-dispatch.component.html
// module id = 2467
// module chunks = 66